enum events {
  TASK_CREATED = "task-created",
  TASK_UPDATED = "task-updated",
  TASK_DELETED = "task-deleted",
  TASKS_CHANGED = "tasks-changed"
}

export default events
